export const categories = [
  {
    title: "Grains",
    items: ["Rice", "Wheat", "Barley", "Maize", "Millets", "Pulses", "Other Grains"],
  },
  {
    title: "Fruits",
    items: [
      "Mangoes", 
      "Bananas", 
      "Apples", 
      "Oranges", 
      "Grapes", 
      "Watermelons", 
      "Papayas", 
      "Seasonal Fruits",
      "Other Fruits"
    ],
  },
  {
    title: "Vegetables",
    items: [
      "Potatoes",
      "Tomatoes",
      "Onions",
      "Leafy Greens",
      "Gourds",
      "Root Vegetables",
      "Seasonal Vegetables",
      "Other Vegetables"
    ],
  },
  {
    title: "Dairy",
    items: [
      "Milk",
      "Ghee",
      "Butter",
      "Paneer",
      "Curd",
      "Buttermilk",
      "Other Dairy Products"
    ],
  },
  {
    title: "Spices",
    items: [
      "Turmeric",
      "Chili",
      "Coriander",
      "Cumin",
      "Cardamom",
      "Cloves",
      "Black Pepper",
      "Other Spices"
    ],
  },
  {
    title: "Organic Products",
    items: [
      "Organic Vegetables",
      "Organic Fruits",
      "Organic Grains",
      "Organic Spices",
      "Other Organic Products"
    ],
  },
  {
    title: "Seeds & Saplings",
    items: [
      "Vegetable Seeds",
      "Fruit Saplings",
      "Flower Seeds",
      "Herb Seeds",
      "Other Seeds"
    ],
  },
  {
    title: "Farm Equipment",
    items: [
      "Tractors",
      "Harvesters",
      "Plows",
      "Irrigation Equipment",
      "Hand Tools",
      "Other Equipment"
    ],
  },
  {
    title: "Fertilizers & Pesticides",
    items: [
      "Organic Fertilizers",
      "Chemical Fertilizers",
      "Bio Fertilizers",
      "Pesticides",
      "Insecticides",
      "Other Agro Chemicals"
    ],
  },
  {
    title: "Farming Services",
    items: [
      "Tractor Rental",
      "Harvesting Services",
      "Transportation",
      "Storage Facilities",
      "Soil Testing",
      "Other Services"
    ],
  }
];

// Business categories for businessman registration dropdown
export const businessCategories = [
  "Grains",
  "Vegetables", 
  "Dairy",
  "Livestock",
  "Spices",
  "Organic Products",
  "Seeds & Saplings",
  "Farm Equipment",
  "Fertilizers & Pesticides",
  "Farming Services"
];